import { Button, customScrollMinimal, Icon } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StyledIcon = styled(Icon)`
  fill: var(--icon-soft);
  cursor: pointer;
`;

export const SubmitButton = styled(Button)`
  align-self: end;
`;

export const AssetsList = styled.div`
  ${customScrollMinimal};
  max-height: 480px;
  overflow-y: auto;
  padding: 2px;
`;
